import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withLogin } from '@catalogo/service-americanas-login/src/hoc/login';
import Logged from './components/logged';
import NotLogged from './components/not-logged';

export const Login = ({ token, name, hasRecommendations, loading, recs, pageType }) => (
  <Wrapper>
    {token ? (
      <Logged name={name} recs={recs} hasRecommendations={hasRecommendations} loading={loading} pageType={pageType} />
    ) : (
      <NotLogged />
    )}
  </Wrapper>
);

Login.propTypes = {
  cookies: PropTypes.object,
};

const Wrapper = styled.div`
  margin-bottom: 10px;
`;

export default withLogin(Login);
